<template>
  <div class="canvasContainer" ref="canvasContainer"></div>
</template>

<script>
import { DxfViewer } from "dxf-viewer";
import * as three from "three";

/** Events: all DxfViewer supported events (see DxfViewer.Subscribe()), prefixed with "dxf-". */
export default {
  name: "DxfViewer",

  props: {
    dxfUrl: {
      default: null,
    },

    fonts: {
      default: null,
    },
    options: {
      default() {
        return {
          clearColor: new three.Color("#fff"),
        //   autoResize: true,
          canvasWidth: 800,
          canvasHeight: 500,
          colorCorrection: true,
        };
      },
    },
  },

  data() {
    return {
      isLoading: false,
      progress: null,
      progressText: null,
      curProgressPhase: null,
      error: null,
    };
  },

  watch: {
    async dxfUrl(dxfUrl) {
      if (dxfUrl !== null) {
        await this.Load(dxfUrl);
      } else {
        this.dxfViewer.Clear();
        this.error = null;
        this.isLoading = false;
        this.progress = null;
      }
    },
  },

  methods: {
    async Load(url) {
      this.isLoading = true;
      this.error = null;
      try {
        await this.dxfViewer.Load({
          url,
          fonts: this.fonts,
          progressCbk: this._OnProgress.bind(this),
          workerFactory: "",
        });
      } catch (error) {
        console.warn(error);
        this.error = error.toString();
      } finally {
        this.isLoading = false;
        this.progressText = null;
        this.progress = null;
        this.curProgressPhase = null;
      }
    },

    /** @return {DxfViewer} */
    GetViewer() {
      return this.dxfViewer;
    },

    _OnProgress(phase, size, totalSize) {
      if (phase !== this.curProgressPhase) {
        switch (phase) {
          case "font":
            this.progressText = "Fetching fonts...";
            break;
          case "fetch":
            this.progressText = "Fetching file...";
            break;
          case "parse":
            this.progressText = "Parsing file...";
            break;
          case "prepare":
            this.progressText = "Preparing rendering data...";
            break;
        }
        this.curProgressPhase = phase;
      }
      if (totalSize === null) {
        this.progress = -1;
      } else {
        this.progress = size / totalSize;
      }
    },
  },

  mounted() {
    this.dxfViewer = new DxfViewer(this.$refs.canvasContainer, this.options);
    const Subscribe = (eventName) => {
      this.dxfViewer.Subscribe(eventName, (e) =>
        this.$emit("dxf-" + eventName, e)
      );
    };
    for (const eventName of [
      "loaded",
      "cleared",
      "destroyed",
      "resized",
      "pointerdown",
      "pointerup",
      "viewChanged",
      "message",
    ]) {
      Subscribe(eventName);
    }
  },

  destroyed() {
    this.dxfViewer.Destroy();
    this.dxfViewer = null;
  },
};
</script>

<style scoped lang="less">
.canvasContainer {
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 100px;
  min-height: 100px;
}
</style>